import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import React from 'react';
import Colors from '../../../colors';

const StyledButton = styled(Button)({
    width: '100%',
    textTransform: 'none',
    borderTop: `1px solid ${Colors.gray}`,
    borderRadius: '0',
    fontFamily: 'jost',
    fontWeight: '400',
});

function FullWidthModalButton({ label, color, onClick }) {
    return (
        <StyledButton variant="text" style={{ color: color }} onClick={onClick}>
            {label}
        </StyledButton>
    );
}

export default FullWidthModalButton